import React from 'react'
import { Link } from 'react-router-dom'
import { routes } from '../../../constants/routes'

// with no nav bar on the booking pages, this is how a client switches to a different kind of booking
const InquiryBackLink = () => (
    <Link to={routes.inquiryIndex.path} className="inquiry-back-link">
        &larr; All booking options
    </Link>
)

export default InquiryBackLink
